import React, { useEffect } from 'react';
import {PageView} from '../../tracking';
import {Row, Col} from 'react-bootstrap';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

function AboutOrthopub(){

    useEffect(() => {
        PageView();
    }, [])

    return(
        <Row className={classNames("mt-3 bg-white mx-0 rounded border")}>
            <Col md={12} className="p-4">
                <h5 className=''>About EditorEase Compliance</h5><hr/>
                <p>
                    Transform your manuscript journey with EditorEase Compliance. Our automated compliance tool scans your uploaded manuscript and generates a detailed report based on journal-specific guidelines.    
                </p>
                <p>
                    Whether you are submitting to a journal for the first time or resubmitting after revision, EditorEase Compliance identifies structural and formatting gaps — helping you take the guesswork out of manuscript preparation. 
                </p>
                <p>
                    Simply upload your manuscript, and download a validation report that highlights what needs to be updated. It is fast, reliable, and designed to save you time while maintaining submission accuracy. 
                </p>
                <div>
                    <h6>EditorEase Compliance Dashboard: Stay Organized, Stay in Control</h6>
                    <ol>
                        <li>
                            {/* <strong>Discover the Perfect Journal: </strong> */}
                            <span className='m-0 p-0'>Access all your uploaded manuscripts in one place.</span>
                        </li>
                        <li>
                            {/* <strong>Formatting Made Easy: </strong> */}
                            <span className='m-0 p-0'>View and manage past compliance reports anytime.</span>
                        </li>
                        <li>
                            {/* <strong>Manage Your Journey: </strong> */}
                            <span className='m-0 p-0'>Securely store, revisit, or remove manuscripts — you stay in control.</span>
                        </li>
                    </ol>
                </div>
                {/* <p>
                    AuthorEase is brought to you by Bone & Joint, an imprint of The British Editorial of Bone & Joint Surgery, a not-for-profit charity and Company limited by Guarantee. Bone & Joint are the publishers of The Bone & Joint Journal and Bone & Joint 360, Open Access journals Bone & Joint Research and Bone & Joint Open, and owners of the digital products OrthoSearch and OrthoMedia.
                </p> */}
                {/* <p>
                    After formatting your manuscript, securely store it in your AuthorEase Dashboard. Revisit it later to reformat for another publication or update its publication journey for your records. Your manuscripts are confidentially kept within your Dashboard, which is password-protected and under your control. Permanently remove them or keep them on your AuthorEase Dashboard indefinitely, giving you full control over your work.
                </p> */}
                {/* <p>
                    After your manuscript has been formatted, you have the option to keep it in your Dashboard on AuthorEase and return to it to re-format for another publication or update its publication journey for your own reference. All your manuscripts held on AuthorEase are kept confidentially within your own Dashboard controlled by a password you set –they can be removed permanently at any time by you or kept on your AuthorEase Dashboard indefinitely.
                </p> */}
                {/* <p>
                    AuthorEase currently offers formatting templates for The Bone & Joint Journal, Bone & Joint Research and Bone & Joint Open, plus a ‘generic’ template which will allow for some formatting across most orthopaedic journals. Templates for five more specific orthopaedic journals are expected to be launched very soon!
                </p>
                <p>
                    Find out more about the pricing models for the journal specific templates and the generic template <Link to='/profile?tab=credits'>here</Link>.
                </p> */}
                {/* <h5><b>Our Offices</b></h5>
                <p className="font-weight-bold">Molecular Connections,</p>
                <p className="mb-0">Heritage Building, #59/2, Kaderanahalli, 100 feet road</p>
                <p className="mb-0">Banashankari 2nd Stage, Bangalore 560070, Karnataka, India</p>
                <p className="mb-0">Tel: +91 80 2669 0145</p>
                <p>Email: <a href="mailto:info@molecularconnections.com?subject=Query about the information&body=Your query here...">info@molecularconnections.com</a></p> */}
            </Col>
        </Row>
    )
}

export default AboutOrthopub;